import {
  commonStrings,
  statusOptions,
  typeOptions,
  colorOptions,
  sizeOptions
} from './common';

export default {
  common: {
    ...commonStrings,
    currentUser: '當前用戶'
  },
  permissionManagement: {
    title: '權限管理'
  },

  // 首頁相關
  home: {
    title: '首頁',
    welcome: '歡迎使用',
    overview: '系統概覽',
    editHome: '編輯首頁',
    finishEdit: '完成編輯',
    saveLayout: '保存佈局',
    addCard: '新增卡片',
    editCard: '編輯卡片',
    cardTitle: '卡片標題',
    cardDescription: '卡片描述',
    selectCardType: '選擇卡片類型',
    deleteCard: '刪除卡片',
    confirmDelete: '確認刪除',
    deleteCardMessage: '確定要刪除此卡片嗎？',
    cardSettings: '卡片設定',
    resizeCard: '調整卡片大小',
    cardType: '卡片類型',
    cardColor: '卡片顏色',
    cardIcon: '卡片圖標',
    cardSize: '卡片大小',
    titleRequired: '請輸入卡片標題',
    titleTooLong: '卡片標題不能超過50個字符',
    typeRequired: '請選擇卡片類型',
    layoutSaved: '佈局保存成功',
    cardDeleted: '卡片刪除成功',
    cardSaved: '卡片保存成功',
    actionExecuted: '操作執行成功',
    stats: {
      devices: '設備總數',
      alerts: '警報數量',
      users: '用戶數量',
      dashboards: '儀表板數量'
    },
    cards: {
      deviceStatus: '設備狀態',
      deviceStatusDesc: '實時監控設備狀態和性能指標',
      recentAlerts: '最近警報',
      recentAlertsDesc: '查看最新的系統警報和通知',
      quickActions: '快速操作',
      quickActionsDesc: '常用功能的快速訪問入口'
    },
    actions: {
      addDevice: '新增設備',
      viewAlerts: '查看警報',
      exportData: '匯出資料',
      settings: '系統設定'
    },
    types: typeOptions,
    colors: colorOptions,
    sizes: sizeOptions
  },

  navigation: {
    title: '導航',
    dashboard: '儀表板',
    dashboardOverview: '儀表板總覽',
    dashboardPreview: '儀表板預覽',
    dashboardList: '儀表板列表',
    dashboardDesign: '儀表板設計',
    deviceManagement: '設備管理',
    equipmentManagement: '設備管理',
    monitoring: '監控管理',
    applicationManagement: '應用管理',
    workflow: '流程管理',
    flow: '流程管理',
    dataPlatform: '數據管理',
    microserviceManagement: '微服務管理',
    systemManagement: '系統管理',
    profile: '個人管理',
    notifications: '通知管理',
    alarm: '警報管理',
    alarmManagement: '警報管理',
    deviceMonitoring: '設備監控',
    cctv: 'CCTV監控',
    inspectionManagement: '檢查管理',
    inspectionReport: '檢查報告',
    permissionManagement: '權限管理',
    userManagement: '用戶管理',
    customDashboard: '自訂儀表板',
    ruleEngine: '規則引擎',
    home: '首頁',
    apiManagement: 'API管理',
    apiInterface: '介面管理',
    apiModel: '物模型管理'
  },

  dashboard: {
    title: '儀表板',
    managementTitle: '儀表板管理',
    addDashboard: '新增儀表板',
    editDashboard: '編輯儀表板',
    name: '儀表板名稱',
    setAsDefault: '設為預設',
    fuxaUrl: 'FUXA URL',
    nameRequired: '請輸入儀表板名稱',
    nameTooLong: '儀表板名稱不能超過50個字符',
    typeRequired: '請選擇儀表板類型',
    statusRequired: '請選擇狀態',
    urlRequired: '請輸入FUXA URL',
    urlInvalid: '請輸入有效的URL',
    searchPlaceholder: '搜尋儀表板...',
    selectedCount: '已選取 {count} 項',
    batchDelete: '批量刪除',
    batchSetDefault: '批量設為預設',
    confirmBatchDelete: '確認批量刪除',
    batchDeleteMessage:
      '您確定要刪除選取的 {count} 個儀表板嗎？此操作無法復原。',
    batchDeleteSuccess: '批量刪除成功',
    batchSetDefaultSuccess: '批量設為預設成功',
    noDashboards: '尚無儀表板',
    createFirst: '創建您的第一個儀表板',
    alertSummary: '告警工單總數量',
    todayNewAlert: '今日新增告警數',
    myTodo: '我的待辦',
    processing: '辦理中',
    myDone: '我的已辦',
    inspectionEquipment: '巡检设备数量',
    unassigned: '未分配',
    totalDevices: '設備總數',
    onlineDevices: '在線設備',
    offlineDevices: '離線設備',
    alertDevices: '警報設備',
    systemStatus: '系統狀態',
    performanceMetrics: '性能指標',
    recentAlerts: '最近警報',
    deviceStatus: '設備狀態',
    systemHealth: '系統健康度',
    type: typeOptions,
    status: statusOptions,
    preview: 'preview',
    default: 'default',
    lastModified: 'lastModified'
  },

  device: {
    title: '設備管理',
    description: '管理系統中的所有設備和相關功能',
    deviceList: '設備列表',
    deviceListDescription: '查看和管理所有設備的基本資訊、狀態和配置',
    subDevice: '子設備',
    subDeviceManagement: '子設備管理',
    subDeviceDescription: '管理設備的子設備和相關配置',
    commandManagement: '命令管理',
    commandManagementDescription: '發送設備指令、查看指令歷史和執行狀態',
    deviceStatusMonitor: '設備狀態監控',
    totalDevices: '設備總數',
    pendingCommands: '待執行',
    addDevice: '新增設備',
    editDevice: '編輯設備',
    deviceName: '設備名稱',
    deviceStatus: '設備狀態',
    deviceType: '設備類型',
    deviceModel: '設備型號',
    deviceId: '設備ID',
    nodeId: '節點ID',
    protocolType: '協議類型',
    mainCircuit: '主電路',
    subCircuit: '子電路',
    commandCount: '命令數量',
    lastOnlineTime: '最後在線時間',
    deviceInfo: '設備資訊',
    deviceConfig: '設備配置',
    deviceCommands: '設備命令',
    deviceHistory: '設備歷史',
    deviceAlerts: '設備警報',
    deviceMaintenance: '設備維護',
    deviceLocation: '設備位置',
    deviceParameters: '設備參數',
    deviceFirmware: '設備韌體',
    deviceNetwork: '設備網路',
    deviceSecurity: '設備安全',
    deviceStatistics: '設備統計概覽',
    totalDeviceCount: '總設備數',
    onlineDeviceCount: '在線設備',
    offlineDeviceCount: '離線設備',
    errorDeviceCount: '故障設備',
    deviceAssets: '設備資產'
  },

  monitoring: {
    title: '監控管理',
    realTimeMonitoring: '即時監控',
    alertManagement: '警報管理',
    alertHistory: '警報歷史',
    alertRules: '警報規則',
    alertSettings: '警報設定',
    alertLevels: '警報等級',
    alertTypes: '警報類型',
    alertStatus: '警報狀態',
    alertTime: '警報時間',
    alertMessage: '警報訊息',
    alertSource: '警報來源',
    alertHandler: '警報處理人',
    alertPriority: '警報優先級',
    alertCategory: '警報分類',
    alertSeverity: '警報嚴重程度',
    alertAcknowledged: '已確認',
    alertUnacknowledged: '未確認',
    alertResolved: '已解決',
    alertPending: '待處理',
    alertProcessing: '處理中'
  },

  workflow: {
    title: '流程管理',
    ruleEngine: '規則引擎',
    workflowDesign: '流程設計',
    workflowExecution: '流程執行',
    workflowHistory: '流程歷史',
    workflowTemplates: '流程模板',
    workflowRules: '流程規則',
    workflowTriggers: '流程觸發器',
    workflowActions: '流程動作',
    workflowConditions: '流程條件',
    workflowVariables: '流程變數',
    workflowScheduling: '流程排程',
    workflowMonitoring: '流程監控',
    workflowAnalytics: '流程分析',
    workflowOptimization: '流程優化',
    workflowList: '流程列表',
    scheduleList: '排程列表'
  },

  dataPlatform: {
    title: '數據管理',
    dashboard: '數據總覽',
    reports: '統計報表',
    inspectionReport: '檢查報告',
    source: '數據源管理',
    tasks: '數據任務',
    dataPlatformMap: '數據管理地圖',
    dataPlatformMapbox: '數據管理 Mapbox',
    dataPlatformLineChart: '數據管理折線圖',
    dataPlatformPieChart: '數據管理圓餅圖'
  },

  application: {
    pageTitle: '應用管理',
    serviceOverview: '應用總覽',
    fuxaConfig: 'Fuxa 配置',
    nodeRedConfig: 'Node-RED 配置'
  },

  microservice: {
    pageTitle: '微服務管理',
    pageDescription: '管理 Docker 容器、Kubernetes 服務和應用堆棧',
    environment: '環境',
    deployStack: '部署堆棧',
    searchPlaceholder: '搜尋容器/堆棧...',
    filterByStatus: '依狀態過濾',
    filterByImage: '依映像過濾',

    // 容器/堆棧屬性
    name: '名稱',
    image: '映像',
    tag: '標籤',
    statusLabel: '狀態',
    ports: '端口',
    cpu: 'CPU',
    memory: '記憶體',
    resources: '資源使用率',
    actions: '操作',
    standalone: '獨立容器',

    // 狀態
    status: {
      running: '運行中',
      stopped: '已停止',
      error: '錯誤',
      restarting: '重啟中'
    },

    // 操作按鈕
    start: '啟動',
    stop: '停止',
    restart: '重啟',
    logs: '日誌',
    monitoring: '監控',
    edit: '編輯',
    duplicate: '複製',
    delete: '刪除',

    // 部署相關
    dockerCompose: 'Docker Compose',
    kubernetesYaml: 'Kubernetes YAML',
    uploadFile: '上傳檔案',
    composeContent: 'Compose 內容',
    composePlaceholder: '貼上 Docker Compose 內容...',
    yamlContent: 'YAML 內容',
    yamlPlaceholder: '貼上 Kubernetes YAML 內容...',
    selectFile: '選擇檔案',
    deploy: '部署',
    deploySuccess: '部署成功',
    deploySuccessMessage: '堆棧已成功部署到選定環境',
    deployError: '部署失敗',
    deployErrorMessage: '部署過程中發生錯誤，請檢查配置',

    // 日誌相關
    containerLogs: '容器日誌',
    autoRefresh: '自動刷新',
    downloadLogs: '下載日誌',
    clearLogs: '清除日誌',

    // 監控相關
    containerMonitoring: '容器監控',
    cpuUsage: 'CPU 使用率',
    memoryUsage: '記憶體使用率',
    networkIO: '網路 I/O',
    diskIO: '磁碟 I/O',

    // 確認對話框
    confirmDelete: '確認刪除',
    deleteWarning: '確定要刪除容器 "{name}" 嗎？此操作無法撤銷。',

    // 環境類型
    environmentTypes: {
      docker: 'Docker',
      kubernetes: 'Kubernetes'
    },

    // 容器類型
    containerTypes: {
      container: '容器',
      stack: '堆棧',
      service: '服務'
    },
    serviceOverview: '服務總覽',
    serviceTable: '服務表格',
    serviceCardGrid: '服務卡片網格',
    serviceSearchInput: '服務搜尋',
    serviceActions: '服務操作',
    environmentSelector: '環境選擇器',
    deployStackModal: '部署堆疊模組',
    fuxaConfig: 'FUXA 配置',
    nodeRedConfig: 'Node-RED 配置'
  },

  user: {
    title: '用戶管理',
    username: '用戶名',
    password: '密碼',
    email: '電子郵件',
    phone: '電話',
    fullName: '全名',
    firstName: '名字',
    lastName: '姓氏',
    department: '部門',
    position: '職位',
    role: '角色',
    permissions: '權限',
    lastLogin: '最後登入',
    loginTime: '登入時間',
    logoutTime: '登出時間',
    loginIp: '登入IP',
    userProfile: '用戶資料',
    userSettings: '用戶設定',
    userPreferences: '用戶偏好',
    userActivity: '用戶活動',
    userSessions: '用戶會話',
    systemAdmin: '系統管理員',
    maintenanceEngineer: '維運工程師',
    monitor: '監控員'
  },

  deviceMonitoring: {
    title: '設備監控',
    description: '即時監控設備狀態和效能指標',
    deviceStatus: '設備狀態',
    realTimeMetrics: '即時指標',
    monitorProperties: '監控屬性',
    deviceStatusDescription: '查看所有設備的即時狀態和基本資訊',
    realTimeMetricsDescription: '監控設備的即時效能指標和資料',
    monitorPropertiesDescription: '配置監控屬性和警報規則'
  },

  userManagement: {
    userName: '用戶姓名',
    loginAccount: '登入帳號',
    organization: '所屬機構',
    organizationType: '機構類型',
    position: '崗位',
    role: '角色',
    freezeUser: '凍結用戶',
    unfreezeUser: '解凍用戶',
    resetPassword: '密碼重置',
    userList: '用戶列表',
    userManagement: '用戶管理',
    resetUser: '重置用戶',
    passwordResetSuccess: '新密碼已發送至用戶信箱',
    resetPasswordConfirm: '確定要將 {username} 的密碼重置為 12345678 嗎？',
    // 新增翻譯
    accountManagement: '帳號管理',
    organizationManagement: '組織管理',
    rolePermissions: '權限管理',
    accountStatus: '帳號狀態',
    active: '啟用',
    inactive: '停用',
    suspended: '暫停',
    addUser: '新增用戶',
    editUser: '編輯用戶',
    deleteUser: '刪除用戶',
    batchOperation: '批次操作',
    status: '狀態'
  },

  role: {
    title: '角色管理',
    roleName: '角色名稱',
    roleDescription: '角色描述',
    rolePermissions: '角色權限',
    roleUsers: '角色用戶',
    roleType: '角色類型',
    roleLevel: '角色等級',
    roleStatus: '角色狀態',
    roleCreation: '角色創建',
    roleModification: '角色修改',
    roleDeletion: '角色刪除',
    roleAssignment: '角色分配',
    roleRevocation: '角色撤銷',
    roleInheritance: '角色繼承',
    roleHierarchy: '角色層級'
  },

  organization: {
    title: '組織管理',
    organizationName: '組織名稱',
    organizationCode: '組織代碼',
    organizationType: '組織類型',
    organizationLevel: '組織等級',
    organizationParent: '上級組織',
    organizationChildren: '下級組織',
    organizationLeader: '組織領導',
    organizationContact: '組織聯絡人',
    organizationAddress: '組織地址',
    organizationPhone: '組織電話',
    organizationEmail: '組織郵箱',
    organizationWebsite: '組織網站',
    organizationDescription: '組織描述',
    organizationStatus: '組織狀態',
    organizationCreation: '組織創建',
    organizationModification: '組織修改'
  },

  inspection: {
    title: '檢查管理',
    inspectionSchedule: '檢查排程',
    inspectionRoute: '檢查路線',
    inspectionReport: '檢查報告',
    inspectionTask: '檢查任務',
    inspectionResult: '檢查結果',
    inspectionStatus: '檢查狀態',
    inspectionType: '檢查類型',
    inspectionFrequency: '檢查頻率',
    inspectionDuration: '檢查時長',
    inspectionArea: '檢查區域',
    inspectionEquipment: '檢查設備',
    inspectionInspector: '檢查員',
    inspectionDate: '檢查日期',
    inspectionTime: '檢查時間',
    inspectionNotes: '檢查備註',
    inspectionPhotos: '檢查照片',
    inspectionVideos: '檢查影片',
    inspectionAlerts: '檢查警報',
    inspectionMaintenance: '檢查維護'
  },

  inspectionSchedule: {
    title: '巡檢排班',
    routePlanning: '路線規劃',
    addSchedule: '新增排班',
    editSchedule: '編輯排班',
    scheduleId: '排班編號',
    time: '時間',
    inspector: '巡檢人員',
    scheduler: '排班人員',
    licensePlateNumber: '車牌號碼',
    task: '任務內容',
    inspectionRoute: '巡檢路線',
    actions: '操作',
    year: '年',
    month: '月',
    sunday: '日',
    monday: '一',
    tuesday: '二',
    wednesday: '三',
    thursday: '四',
    friday: '五',
    saturday: '六'
  },

  notification: {
    title: '通知管理',
    notificationCenter: '通知中心',
    notificationSettings: '通知設定',
    notificationHistory: '通知歷史',
    notificationTypes: '通知類型',
    notificationChannels: '通知管道',
    notificationTemplates: '通知模板',
    notificationRules: '通知規則',
    notificationScheduling: '通知排程',
    notificationDelivery: '通知發送',
    notificationStatus: '通知狀態',
    notificationPriority: '通知優先級',
    notificationRead: '已讀',
    notificationUnread: '未讀',
    notificationSent: '已發送',
    notificationFailed: '發送失敗',
    notificationPending: '待發送',
    notificationProcessing: '發送中',
    assignedToYou: '已指派給您'
  },

  system: {
    title: '系統管理',
    globalManagement: '全域管理',
    organizationOverview: '組織總覽',
    userManagement: '用戶管理',
    rolePermission: '角色權限',
    organizationManagement: '組織管理',
    positionManagement: '職位管理',
    systemSettings: '系統設定',
    configService: '配置服務',
    monitoringAndLogs: '監控與日誌'
  },

  auth: {
    title: '認證',
    login: '登入',
    logout: '登出',
    register: '註冊',
    forgotPassword: '忘記密碼',
    resetPassword: '重設密碼',
    changePassword: '變更密碼',
    verifyEmail: '驗證電子郵件',
    verifyPhone: '驗證電話',
    twoFactorSetup: '雙重認證設定',
    rememberMe: '記住我',
    staySignedIn: '保持登入',
    signInWith: '使用以下方式登入',
    createAccount: '建立帳戶',
    alreadyHaveAccount: '已有帳戶',
    dontHaveAccount: '沒有帳戶',
    loginSuccess: '登入成功',
    loginFailed: '登入失敗',
    logoutSuccess: '登出成功',
    sessionExpired: '會話已過期',
    unauthorized: '未授權',
    forbidden: '禁止訪問'
  },

  error: {
    title: '錯誤',
    pageNotFound: '頁面未找到',
    serverError: '伺服器錯誤',
    networkError: '網路錯誤',
    timeoutError: '超時錯誤',
    validationError: '驗證錯誤',
    permissionError: '權限錯誤',
    authenticationError: '認證錯誤',
    authorizationError: '授權錯誤',
    resourceNotFound: '資源未找到',
    serviceUnavailable: '服務不可用',
    badRequest: '錯誤請求',
    forbidden: '禁止訪問',
    internalServerError: '內部伺服器錯誤',
    gatewayTimeout: '閘道超時',
    tooManyRequests: '請求過多'
  },

  time: {
    now: '現在',
    today: '今天',
    yesterday: '昨天',
    tomorrow: '明天',
    thisWeek: '本週',
    lastWeek: '上週',
    nextWeek: '下週',
    thisMonth: '本月',
    lastMonth: '上月',
    nextMonth: '下月',
    thisYear: '今年',
    lastYear: '去年',
    nextYear: '明年',
    morning: '上午',
    afternoon: '下午',
    evening: '晚上',
    night: '夜間',
    seconds: '秒',
    minutes: '分鐘',
    hours: '小時',
    days: '天',
    weeks: '週',
    months: '月',
    years: '年'
  },

  i18n: {
    title: '多國語言化測試',
    description: '這是一個用於測試多國語言化功能的頁面',
    welcome: '歡迎使用多國語言化功能',
    language: '語言',
    currentLanguage: '當前語言',
    changeLanguage: '切換語言',
    languageSettings: '語言設定',
    languageSwitcher: 'languageSwitcher',
    languageCode: 'languageCode',
    languageName: 'languageName',
    currentTime: 'currentTime'
  },

  alarm: {
    title: '警報管理',
    rules: '警報規則',
    list: '警報列表',
    templates: '警報模板',
    notifications: '警報通知',
    alarmList: '警報列表',
    alarmHistory: '警報歷史',
    alarmRules: '警報規則',
    alarmSettings: '警報設定',
    alarmLevels: '警報等級',
    alarmTypes: '警報類型',
    alarmStatus: '警報狀態',
    alarmTime: '警報時間',
    alarmMessage: '警報訊息',
    alarmSource: '警報來源',
    alarmHandler: '警報處理人',
    alarmPriority: '警報優先級',
    alarmCategory: '警報分類',
    alarmSeverity: '警報嚴重程度',
    alarmAcknowledged: '已確認',
    alarmUnacknowledged: '未確認',
    alarmResolved: '已解決',
    alarmPending: '待處理',
    alarmProcessing: '處理中',
    alarmStatistics: '警報統計',
    alarmTrends: '警報趨勢',
    alarmReports: '警報報告',
    alarmNotifications: '警報通知',
    alarmEscalation: '警報升級',
    alarmSuppression: '警報抑制',
    alarmCorrelation: '警報關聯',
    alarmForecasting: '警報預測',
    alarmOptimization: '警報優化'
  },

  alarmMessages: {
    title: '告警訊息',
    description: '管理系統中的所有告警訊息',
    totalAlarms: '總告警數',
    unprocessed: '未處理',
    processing: '處理中',
    processed: '已處理',
    refresh: '刷新',
    batchProcess: '批次處理',
    exportReport: '匯出報告',
    clearProcessed: '清除已處理',
    status: '處理狀態',
    priority: '優先級',
    deviceType: '設備類型',
    keywordSearch: '關鍵字搜尋',
    filter: '篩選',
    alarmDetail: '告警詳情',
    deviceSn: '設備序號',
    alarmNumber: '告警編號',
    deviceLocation: '設備位置',
    alarmValue: '告警值',
    createTime: '建立時間',
    updateTime: '更新時間',
    alarmDescription: '告警描述',
    processNote: '處理備註',
    unknown: '未知',
    noDescription: '無描述',
    startProcess: '開始處理',
    completeProcess: '完成處理',
    close: '關閉',
    batchProcessAlarm: '批次處理告警',
    selectAction: '選擇操作',
    cancel: '取消',
    confirm: '確認',
    low: '低',
    normal: '普通',
    high: '高',
    critical: '緊急',
    camera: '攝像頭',
    accessControl: '門禁',
    sensor: '感測器',
    controller: '控制器',
    batchMarkProcessing: '批次標記為處理中',
    batchMarkProcessed: '批次標記為已處理',
    batchDelete: '批次刪除',
    actions: '操作'
  },

  integratedMonitoring: {
    title: '綜合監控中心',
    description: '一站式監控管理平台 - 設備狀態、環境參數、安全警報全方位監控',
    totalDevices: '設備總數',
    onlineDevices: '在線設備',
    activeAlarms: '活躍告警',
    todayAlarms: '今日告警',
    unreadNotifications: '未讀通知',
    systemHealth: '系統健康度',
    realtimeAlarms: '實時告警',
    viewAll: '查看全部',
    noAlarms: '暫無告警',
    deviceStatusDistribution: '設備狀態分布',
    environmentMonitoring: '環境監控',
    devicePerformanceTrend: '設備性能趨勢',
    alarmTrendStatistics: '告警趨勢統計',
    monitoringDataStorage: '監控資料儲存管理',
    threeModuleIntegration: '三大模組整合管理',
    monitoringManagement: '監控管理'
  },

  cctv: {
    server: '伺服器',
    user: '使用者',
    clearSettings: '清除設定',
    enterModifyUrl: '請輸入修改網址',
    cancel: '取消',
    save: '儲存'
  },

  customDashboard: {
    editorNotConfigured: '自訂儀表板編輯器未配置',
    serviceNotConfigured: '自訂儀表板服務未配置',
    checkEnvironmentVariable: '請檢查環境變數 VITE_FUXA_HOST 是否已設置'
  },

  inspectionReport: {
    title: '巡檢回報',
    reported: '已回報',
    notReported: '未回報',
    inspectionId: '拼接編號',
    scheduledTime: '規定巡檢時間',
    actualTime: '實際巡檢時間',
    inspectionPoint: '巡檢點',
    taskContent: '任務內容',
    inspectionPersonnel: '巡檢人員',
    status: '狀態',
    reportContent: '回報內容',
    attachments: '附件',
    actions: '操作',
    abnormalId: '異常編號',
    abnormalType: '異常類型',
    abnormalContent: '異常內容',
    discoveryLocation: '發現地點',
    discoveredBy: '發現人員',
    assignedPersonnel: '指派處理人員',
    discoveryTime: '發現時間',
    completionTime: '結束時間',
    reportList: '報告列表'
  },

  deviceStatus: {
    title: '設備狀態',
    description: '監控與管理所有設備的狀態',
    totalDevices: '設備總數',
    onlineDevices: '在線設備',
    offlineDevices: '離線設備',
    abnormalDevices: '異常設備',
    statusDistribution: '狀態分布',
    deviceTypeStats: '設備類型統計',
    refreshStatus: '刷新狀態',
    exportReport: '匯出報表',
    batchActions: '批次操作',
    status: '狀態',
    deviceType: '設備類型',
    location: '位置',
    deviceNameSn: '設備名稱/序號',
    applyFilters: '套用篩選',
    deviceDetail: '設備詳情',
    deviceName: '設備名稱',
    deviceSn: '設備序號',
    ipAddress: 'IP 位址',
    firstOnlineTime: '首次上線時間',
    lastOnlineTime: '最後上線時間',
    deviceDescription: '設備描述',
    noDescription: '無描述',
    close: '關閉',
    chooseAction: '選擇操作',
    newLocation: '新位置',
    cancel: '取消',
    confirm: '確認',
    actions: '操作',
    online: '在線',
    offline: '離線',
    abnormal: '異常',
    camera: '攝影機',
    accessControl: '門禁',
    sensor: '感測器',
    controller: '控制器',
    floor1Lobby: '一樓大廳',
    floor2Office: '二樓辦公室',
    parking: '停車場',
    serverRoom: '機房',
    restart: '重啟',
    updateLocation: '更新位置',
    syncTime: '同步時間'
  },
  equipment: {
    title: '設備管理',
    description: '管理系統中的所有設備和相關功能',
    equipmentList: '設備列表',
    equipmentListDescription: '查看和管理所有設備的基本資訊、狀態和配置',
    addEquipment: '新增設備',
    editEquipment: '編輯設備',
    equipmentDetail: '設備詳情',
    commandManagement: '命令管理',
    batchEdit: '批次編輯',
    importModal: '匯入模組'
  },
  flow: {
    title: '流程管理',
    description: '管理系統中的工作流程和排程',
    workflowList: '工作流程列表',
    workflowDesign: '工作流程設計',
    scheduleList: '排程列表'
  },

  rolePermission: {
    roleList: '權限管理',
    addRole: '新增角色',
    editRole: '編輯角色',
    roleDetail: '角色詳情',
    roleName: '角色名稱',
    roleDescription: '角色描述',
    rolePermissions: '角色權限'
  },
  positionManagement: {
    positionList: '職位列表',
    addPosition: '新增職位',
    editPosition: '編輯職位',
    positionDetail: '職位詳情',
    positionName: '職位名稱',
    positionDescription: '職位描述'
  },
  organizationManagement: {
    organizationList: '組織管理',
    addOrganization: '新增組織',
    editOrganization: '編輯組織',
    organizationDetail: '組織詳情',
    organizationName: '組織名稱',
    organizationDescription: '組織描述',
    remarks: '備註'
  },
  apiManagement: {
    apiInterface: '介面管理',
    apiModel: '物模型管理',
    addApi: '添加API',
    addModel: '添加物模型',
    generateLib: '生成庫文件',
    searchInterfaceId: '輸入介面標識',
    searchInterfacePath: '輸入介面路徑',
    searchModule: '輸入模塊標識',
    module: '模塊標識',
    interfaceId: '介面標識',
    url: 'URL',
    method: '請求方式',
    createdAt: '加入時間',
    updatedAt: '更新時間',
    action: '操作',
    collectorLabel: '擷取器標識',
    selectCollector: '選擇擷取器',
    gatewayUid: '網關UID',
    selectGateway: '選擇網關',
    moduleDesc: '模塊說明',
    selectModule: '選擇模塊',
    interfaceIds: '介面標識集合',
    interfaceIdsPlaceholder: '多個介面標識以逗號分隔',
    interval: '時間間隔',
    collectorA: '擷取器A',
    collectorB: '擷取器B',
    gatewayA: '網關A',
    gatewayB: '網關B',
    moduleA: '模塊A',
    moduleB: '模塊B',
    temperatureSensor: '溫度感測',
    pressureSensor: '壓力感測'
  },
  search: {
    placeholder: '搜尋功能、頁面或設定...',
    searching: '搜尋中...',
    noResults: '找不到相關結果',
    noResultsDesc: '請嘗試使用不同的關鍵詞，或查看下方的熱門功能',
    popularFeatures: '熱門功能',
    searchTips: '搜尋提示',
    tip1: '使用功能名稱進行搜尋，如「設備管理」、「警報」',
    tip2: '使用快捷鍵 Ctrl+K (Windows) 或 Cmd+K (Mac) 快速開啟搜尋',
    tip3: '搜尋結果會根據相關性自動排序',
    // 新增的 sitemap 相關 key
    frequentlyUsed: '個人常用功能',
    fullSitemap: '完整網站地圖',
    categoryHome: '首頁',
    categoryDashboard: '儀表板',
    categoryDevicemanagement: '設備管理',
    categoryMonitoring: '設備監控',
    categoryEquipment: '設備管理',
    categoryFlow: '流程管理',
    categoryWorkflow: '流程管理',
    categoryDataplatform: '資料管理',
    categoryData: '資料管理',
    categoryMicroservicemanagement: '微服務管理',
    categoryApimanagement: 'API管理',
    categoryInspectionmanagement: '檢查管理',
    categoryNotificationmanagement: '通知管理',
    categorySystemmanagement: '系統管理',
    categorySystem: '系統管理',
    // 搜尋結果描述
    dashboardDesc: '查看和管理儀表板',
    dashboardListDesc: '瀏覽所有儀表板列表',
    dashboardDesignDesc: '設計和編輯自定義儀表板',
    deviceMonitoringDesc: '監控設備狀態和性能',
    deviceStatusDesc: '查看設備實時狀態',
    realTimeMetricsDesc: '查看實時資料指標',
    equipmentManagementDesc: '管理設備和資產',
    deviceListDesc: '查看設備列表',
    flowDesc: '管理工作流程和規則',
    workflowListDesc: '查看工作流程列表',
    dataPlatformDesc: '數據管理和可視化',
    microserviceDesc: '管理微服務配置',
    apiManagementDesc: '管理 API 介面和模型',
    alarmDesc: '處理警報事件',
    inspectionReportDesc: '查看檢查報告',
    systemManagementDesc: '系統設定和管理',
    // 新增缺失的翻譯鍵值
    homeDesc: '系統首頁和概覽',
    monitoringDesc: '設備監控和管理',
    devicemanagementDesc: '設備管理和配置',
    dataplatformDesc: '數據管理和可視化',
    microservicemanagementDesc: '微服務管理和配置',
    apimanagementDesc: 'API 介面管理',
    inspectionmanagementDesc: '檢查報告管理',
    notificationmanagementDesc: '通知系統管理',
    systemmanagementDesc: '系統設定和管理',
    // 子項目描述
    navigationdashboardListDesc: '瀏覽所有儀表板列表',
    navigationdashboardDesignDesc: '設計和編輯自定義儀表板',
    navigationdashboardPreviewDesc: '預覽儀表板效果',
    deviceMonitoringdeviceStatusDesc: '查看設備實時狀態',
    deviceMonitoringrealTimeMetricsDesc: '查看實時資料指標',
    deviceMonitoringmonitorPropertiesDesc: '監控設備屬性',
    devicedeviceListDesc: '查看設備列表',
    devicesubDeviceManagementDesc: '管理子設備',
    devicecommandManagementDesc: '設備命令管理',
    flowworkflowListDesc: '查看工作流程列表',
    flowworkflowDesignDesc: '設計工作流程',
    flowscheduleListDesc: '查看排程列表',
    dataPlatformdataPlatformMapDesc: '數據管理地圖',
    dataPlatformdataPlatformMapboxDesc: '數據管理 Mapbox',
    dataPlatformdataPlatformLineChartDesc: '數據管理線圖',
    dataPlatformdataPlatformPieChartDesc: '數據管理圓餅圖',
    microserviceserviceOverviewDesc: '服務概覽',
    microservicefuxaConfigDesc: 'Fuxa 配置',
    microservicenodeRedConfigDesc: 'Node-RED 配置',
    apiManagementapiInterfaceDesc: 'API 介面管理',
    apiManagementapiModelDesc: 'API 模型管理',
    alarmalarmListDesc: '警報列表',
    inspectionReportreportListDesc: '檢查報告列表',
    notificationnotificationCenterDesc: '通知中心',
    notificationnotificationSettingsDesc: '通知設定',
    notificationnotificationHistoryDesc: '通知歷史',
    systemglobalManagementDesc: '全域管理',
    systemconfigServiceDesc: '配置服務',
    systemmonitoringAndLogsDesc: '監控和日誌',
    userManagementuserListDesc: '用戶管理',
    rolePermissionroleListDesc: '角色權限管理',
    positionManagementpositionListDesc: '職位管理',
    organizationManagementorganizationListDesc: '組織管理',
    systemsystemSettingsDesc: '系統設定',
    // 其他可能遺漏的翻譯鍵值
    navigationhomeDesc: '系統首頁',
    navigationdashboardDesc: '儀表板管理',
    navigationdeviceMonitoringDesc: '設備監控',
    navigationequipmentManagementDesc: '設備管理',
    navigationflowDesc: '流程管理',
    navigationdataPlatformDesc: '數據管理',
    navigationmicroserviceManagementDesc: '微服務管理',
    navigationapiManagementDesc: 'API管理',
    navigationalarmDesc: '警報管理',
    navigationinspectionReportDesc: '檢查報告',
    navigationnotificationsDesc: '通知管理',
    navigationsystemManagementDesc: '系統管理',
    deviceDesc: '設備管理',
    userManagementDesc: '用戶管理',
    rolePermissionDesc: '角色權限',
    positionManagementDesc: '職位管理',
    organizationManagementDesc: '組織管理'
  },

  profile: {
    title: '個人管理',
    personalProfile: '個人檔案',
    personalInfo: '個人資料',
    profileDescription: '其他使用者可透過公司與名稱指定您',
    userName: '用戶姓名',
    loginAccount: '登入帳號',
    organization: '所屬機構',
    organizationType: '機構類型',
    department: '部門',
    position: '職務',
    role: '角色',
    gender: '性別',
    genderMale: '男',
    genderFemale: '女',
    birthday: '生日',
    currentPassword: '當前密碼',
    newPassword: '新密碼',
    confirmPassword: '確認新密碼',
    changePassword: '變更密碼',
    passwordMismatch: '新密碼與確認密碼不一致',
    interfaceLanguage: '介面語言',
    systemTimezone: '系統時區',
    traditionalChinese: '繁體中文',
    english: 'English',
    preferences: '偏好設定',
    savePreferences: '儲存偏好設定',
    resetPassword: '重設密碼',
    accountSettings: '帳戶設定',
    securitySettings: '安全設定',
    notificationPreferences: '通知偏好',
    languageSettings: '語言設定',
    themeSettings: '主題設定',
    privacySettings: '隱私設定',
    passwordChange: '密碼變更',
    passwordChangeSuccess: '密碼修改成功',
    emailVerification: '電子郵件驗證',
    phoneVerification: '電話驗證',
    twoFactorAuth: '雙重認證',
    loginHistory: '登入歷史',
    activityLog: '活動日誌',
    dataExport: '資料匯出',
    accountDeletion: '帳戶刪除'
  },

  sidebar: {
    expandAll: '展開全部',
    collapseAll: '收合全部'
  },

  footer: {
    termsOfService: '服務條款',
    privacyPolicy: '隱私政策'
  }
};
// (See <attachments> above for file contents. You may not need to search or read the file again.)
// 測試 i18n 顯示用：
// <template>
//   <div>{{ $t('navigation.dashboard') }}</div>
// </template>
